import { makeStyles } from 'tss-react/mui';

interface SearchbarStyleProps {
  isFullWidthSearchBar?: boolean;
  isDriversFlagEnabled?: boolean;
  useAltInputBackground?: boolean;
}

const useStyles = makeStyles<SearchbarStyleProps>()(
  (
    theme,
    { isFullWidthSearchBar, isDriversFlagEnabled, useAltInputBackground }
  ) => ({
    searchContainer: {
      display: 'flex',
      width: '100%',
      gap: '12px',
      [theme.breakpoints.up('lg')]: {
        width: isFullWidthSearchBar ? '100%' : '460px',
      },
    },
    searchDropdown: {
      display: 'flex',
      minWidth: '120px',
      borderRadius: '8px',
      height: '46px',
      '&.Mui-focused:not(.Mui-disabled):not(.Mui-error) .MuiOutlinedInput-notchedOutline':
        {
          border: `2px solid ${theme.new.color.brand[600]}`,
          boxShadow: `0 0 0 2px ${theme.new.color.brand[200]}`,
        },
      '&:focus-visible': {
        outline: `2px solid ${theme.new.color.brand[600]}`,
        outlineOffset: '2px',
      },
      '& .MuiSelect-select.MuiSelect-outlined.MuiOutlinedInput-input': {
        fontSize: '0.875rem',
        backgroundColor: theme.new.color.background.input,
        borderRadius: '8px',
      },
      [theme.breakpoints.down('md')]: {
        minWidth: '70px',
      },
    },
    searchField: {
      '& .MuiOutlinedInput-root.MuiInputBase-root': {
        height: '36px',
      },
      '& .MuiOutlinedInput-root.MuiInputBase-root.MuiInputBase-formControl': {
        padding: '0 28px 0 10px',
      },
      '& input': {
        fontSize: '0.875rem',
      },
      '& svg': {
        display: 'none',
      },
    },
    textField: {
      position: 'relative',
      '& label': {
        textTransform: 'none',
      },
      '& input': {
        padding: isDriversFlagEnabled ? '12px 8px 12px 0px' : '12px 8px',
      },
      '& .MuiOutlinedInput-root.MuiInputBase-root': {
        minHeight: '46px',
        backgroundColor: useAltInputBackground
          ? theme.new.color.background.input
          : theme.new.color.common.white,
        borderRadius: '8px',
      },
      '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
        border: `2px solid ${theme.new.color.brand[600]}`,
        boxShadow: `0 0 0 2px ${theme.new.color.brand[200]}`,
      },
      '& input:focus-visible': {
        outline: 'none',
      },
      '& .MuiInputAdornment-positionStart': {
        marginRight: '4px',
        height: '16px',
        width: '16px',
      },

      // Only apply autofill styles when useAltInputBackground is true.
      // this is used to prevent the white background from showing when the input is autofilled
      ...(useAltInputBackground && {
        '& .MuiOutlinedInput-input:-webkit-autofill, & .form-control:-webkit-autofill':
          {
            transition: 'background-color 5000s ease-in-out 0s !important',
            boxShadow: 'none !important',
            backgroundColor: 'transparent !important',
          },
      }),
    },
    closeIconContainer: {
      position: 'absolute',
      top: 0,
      bottom: 0,
      right: 0,
      padding: '0 3px 0 0',
      '& svg': {
        transform: 'scale(0.6)',
      },
      '&.Mui-disabled svg': {
        fill: theme.new.color.grey[400],
      },
      '&:focus-visible': {
        outline: `2px solid ${theme.new.color.brand[600]}`,
        outlineOffset: '2px',
        borderRadius: '4px',
      },
    },
    closeIcon: {
      fill: theme.new.color.textSecondary,
      cursor: 'pointer',
    },
  })
);

export default useStyles;
